import MagicRenderer from "./index";
module.exports = MagicRenderer;
